import * as Types from 'src/actions/project/investment/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Person from 'src/entities/Person';
import IndexResponse from 'src/value-objects/IndexResponse';

export interface GetProjectInvestedAttempt extends Action {
  type: Types.GET_PROJECT_INVESTED_ATTEMPT;
}

export interface GetProjectInvestedSuccess extends Action {
  type: Types.GET_PROJECT_INVESTED_SUCCESS;
  payload: {
    projectInvested: Person[],
    userInvested: boolean
  };
}

export interface GetProjectInvestedFailure extends Action {
  type: Types.GET_PROJECT_INVESTED_FAILURE;
}

export type GetProjectInvestedAction =
  GetProjectInvestedAttempt
  | GetProjectInvestedSuccess
  | GetProjectInvestedFailure;

export interface GetProjectInvestedThunk extends ThunkAction<Promise<GetProjectInvestedAction>, RootState, string> {
}

export const getProjectInvestedAttempt: ActionCreator<GetProjectInvestedAttempt> = () => (
  {
    type: Types.GET_PROJECT_INVESTED_ATTEMPT
  }
);

export const getProjectInvestedSuccess: ActionCreator<GetProjectInvestedSuccess> = (
  invested: { projectInvested: Person[], userInvested: boolean }) => (
  {
    type: Types.GET_PROJECT_INVESTED_SUCCESS,
    payload: invested
  }
);

export const getProjectInvestedFailure: ActionCreator<GetProjectInvestedFailure> = () => (
  {
    type: Types.GET_PROJECT_INVESTED_FAILURE
  }
);

export const getProjectInvested: ActionCreator<GetProjectInvestedThunk> =
  (projectId: number, physicalPersonId: number): GetProjectInvestedThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetProjectInvestedAction> => {
      dispatch(getProjectInvestedAttempt());

      return ApiClient.projectInvested.index({projectId: projectId})
        .then((response: AxiosResponse<IndexResponse<Person>>): GetProjectInvestedSuccess => {
          const projectInvested: Person[] = response.data.content;

          const investedUser = projectInvested.filter(
            element => Number(element.id) === Number(physicalPersonId)).length > 0;
          return dispatch(getProjectInvestedSuccess({
            projectInvested: projectInvested,
            userInvested: investedUser,
          }));
        }).catch((): GetProjectInvestedFailure => {
          return dispatch(getProjectInvestedFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/investment/get/GetProjectInvested.actions.tsx